export default "__VITE_ASSET__9a25f415__"